<template>
  <base-tabs-view
    :tabs="Tabs"
  />
</template>

<script>
import BaseTabsView from '@/components/shared/base/base-tabs-view'
import BaseTabsViewMixin from '@/mixins/base-tabs-view-mixin'

export default {
  name: 'UserManagementUsers',
  components: {
    BaseTabsView
  },
  mixins: [
    BaseTabsViewMixin
  ],
  computed: {
    Tabs () {
      return [
        {
          component: 'user-management-users-overview',
          idComponent: this.constantMixin.menuItem.userManagement.users.general,
          name: this.TextMixin_GetTab('overview')
        },
        {
          component: 'user-management-users-detail',
          idComponent: this.constantMixin.menuItem.userManagement.users.general,
          disabled: !this.ContentMixin_Element,
          name: this.TextMixin_GetTab(this.BaseTabsViewMixin_GetDetailsTab(), this.TextMixin_GetParameter('user'))
        }
      ]
    }
  }
}
</script>
